import { Component, OnInit } from "@angular/core";
import { Spinkit } from "ng-http-loader";
import {
	ActivatedRoute,
	Router,
	NavigationEnd,
	ActivationEnd,
	RoutesRecognized,
	ChildActivationEnd,
	ResolveStart,
	ActivationStart,
	NavigationStart
} from "@angular/router";
import { MessageService } from "./services/message.service";
import { filter, map, mergeMap, take, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { ValidationService } from "./services/validation.services";
import { BaseValidationResponse, ConfigurazioneCaptcha } from "./interfaces/utilities";
import { UsersService } from "./services/user.service";
import { LanguagesService } from "./services/languages.service";
import { Profilo } from "./interfaces/user";
import { Lingua } from "./interfaces/language";
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ListaErrori } from "./interfaces/error";
import { ConfigurationService } from "./services/configuration.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.css"]
})
export class AppComponent {
	public spinkit = Spinkit;
	title = "sanremo-fe-anonym";
	breadcrumb: Observable<string>;
	profile:Profilo;
	captchaConfiguration: ConfigurazioneCaptcha;
	lingua:Lingua;
	appError;
	lang: string = "ITA";
	languageMap:Map<string, string> = new Map<string, string>();
	isCollapsed = true;

	constructor(
		private messageService: MessageService,
		private usersService: UsersService,
		private languagesService: LanguagesService,
		private router: Router,
		private bsLocaleService : BsLocaleService,
		private activeRoute: ActivatedRoute,
		private validationsService: ValidationService,
		private configurationsService: ConfigurationService
	) { }

	ngOnInit() {
		this.languageMap.set("ENG", "en");
		this.languageMap.set("ITA", "it");
		this.getUserProfile();
		this.getCaptchaConfiguration();
		this.getValidationsList();

		this.breadcrumb = this.router.events.pipe(
			// tap(e => console.log(e)),
			// filter(e => e instanceof NavigationEnd),
			map(() => {
				let route = this.activeRoute;

				while (route.firstChild) {
					route = route.firstChild;
				}

				return route;
			}),
			filter(route => route.outlet === "primary"),
			mergeMap(route => route.data),
			map(data => data["breadcrumb"])
		);
	}

	getUserProfile() : void {
		this.usersService.getProfile().pipe(
			tap((data:Profilo)=> {
				data.Utente.linguaDefault ? this.getLanguage(data.Utente.linguaDefault) : this.getLanguage("ITA");
				data.Utente.linguaDefault ? this.getErrors(data.Utente.linguaDefault) : this.getErrors("ITA");
			})
		).subscribe((data:Profilo)=> {
				this.profile = data;
				this.usersService.currentUser.next(this.profile);
			},
				error=>{
					this.getLanguageAndErrors("ITA");
					this.appError = true;
				}
			);
	}

	getCaptchaConfiguration() : void {
		this.configurationsService.getCaptchaConfiguration().pipe(
			tap((data:ConfigurazioneCaptcha)=> {})
		).subscribe((data:ConfigurazioneCaptcha)=> {
				this.captchaConfiguration = data;
				this.configurationsService.configuration.next(this.captchaConfiguration);
			},
				error=>{
					this.appError = true;
				}
			);
	}

	getLanguage(value: string): void {
		this.lang = value;
		this.bsLocaleService.use(this.languageMap.get(this.lang));
		this.languagesService.getLanguage(value).pipe(
			tap((data: Lingua) => this.languagesService.createDictionary(data.linguaggi))
		).subscribe((data: Lingua) => this.lingua = data);
	}

	getErrors(value : string) : void {
		this.languagesService.getErrors(value).pipe(
			tap((data : ListaErrori) => {
				if(data.errori)
					this.languagesService.createErrorDictionary(data.errori);
			})
		).subscribe();
	}

	getLanguageAndErrors(value : string) : void {
		this.lingua = null;
		this.getLanguage(value);
		this.getErrors(value);
	}

	getValidationsList(){
		this.validationsService.getValidationsList()
			.subscribe((data:BaseValidationResponse)=>{
				if(data.esito == 0){
					this.validationsService.validatorsList.next(data.validazioni);
				}
			})
	}
}
